import React, { useState } from 'react';
import {
  CompanyInfoElements,
  CompanyInformationContainer,
} from '../../components/redesignComponents/ResultPageComponents/v2/QuotationCard.styles';
import AdriaticInfoModal from '../../components/redesignComponents/Modal/AdriaticInfoModal';
import infoIcon from '../../../assets/redesign_icons/info-icon.svg';
import preventiveIcon from '../../../assets/redesign_icons/preventivo-icon.svg';
import preContractIcon from '../../../assets/redesign_icons/pre-contract-icon.svg';

import {
  apiDownloadManuallyAddedQuotationDocument,
  downloadResourceDocs,
} from '../../../services/axios-client/axeCommons';
import PrimaInfoModal from '../../components/redesignComponents/Modal/PrimaInfoModal';
import ProfessionInfoModal from '../../components/redesignComponents/Modal/ProfessionInfoModal';
import TutelaLegaleInfoModal from '../../components/redesignComponents/Modal/TutelaLegaleInfoModal';
import SaluteInfoModal from '../../components/redesignComponents/Modal/SaluteInfoModal';
import CasaInfoModal from '../../components/redesignComponents/Modal/CasaInfoModal';
import AncillariInfoModal from '../../components/redesignComponents/Modal/AncillariInfoModal';
import ProfessionWeBindModal from '../../components/redesignComponents/Modal/ProfessionWeBindModal';
import axe from '../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../services/axios-client/axeHelpers';
import MalattiaNobisModal from '../../components/redesignComponents/Modal/MalattiaNobisModal';
import GenialPiuInfoModal from '../../components/redesignComponents/Modal/GenialPiuInfoModal';
import AmtrustInfoModal from '../../components/redesignComponents/Modal/AmTrustInfoModal';
import GlobalAssistanceInfoModal from '../../components/redesignComponents/Modal/GlobalAssistanceTutelaInfoModal';
import CondominioNobisModal from '../../components/redesignComponents/Modal/CondominioNobisModal';
import RcFamigliaNobisModal from '../../components/redesignComponents/Modal/RcFamigliaNobisModal';
import InvaliditaPermanenteInfortunio from '../../components/redesignComponents/Modal/InvaliditaPermanenteInfortunio';
import FacileCompaniesInfoModal from '../../components/redesignComponents/Modal/PreventivasInfoModal';
import SanitariaStranieriInfoModal from '../../components/redesignComponents/Modal/SanitariaStranieriInfoModal';

function CompanyInfoComponent({
  quote,
  guaranteesPrima,
  set_informativi,
  docs,
  extensions,
  requestToken,
  selectableExtensions,
  profession,
  requestInfo,
}) {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(!showModal);
  };

  const downloadDocument = async (document_id) => {
    const response = await apiDownloadManuallyAddedQuotationDocument(
      document_id,
    );
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.data.contents;
    alink.download = response.data.data.data.filename;
    alink.click();
  };

  const downloadModuloDiProposta = async () => {
    const res = await axe.get(
      `/quotations/${quote.id}/modulo-di-proposta/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  // Facile returns one or more PDFs per quote (Set informativo, etc.) in
  // `quote.quotation_data_facile.files`. We render them as clickable links
  // alongside the "Maggiori informazioni" modal trigger so the broker can
  // open the company-supplied document directly.
  //
  // We always present these as "Informativa Precontrattuale" in the UI,
  // regardless of how Facile labels them ("Set informativo",
  // "company_information_package", etc.) — keeps the user-facing copy
  // consistent with the other companies' cards.
  const renderFacileFiles = () => {
    const files = quote.quotation_data_facile?.files;
    if (!Array.isArray(files) || files.length === 0) return null;
    return files.map((file, idx) => (
      <CompanyInfoElements
        key={`facile-file-${idx}`}
        onClick={() => window.open(file.url, '_blank', 'noopener,noreferrer')}
        title="Informativa Precontrattuale"
      >
        <img src={preContractIcon} alt="" />
        <p>Informativa Precontrattuale</p>
      </CompanyInfoElements>
    ));
  };

  return (
    <>
      {showModal && (quote.company_id === 1 || quote.company_id === 17) && (
        <AdriaticInfoModal quotation={quote} setShowModal={setShowModal} />
      )}
      {showModal && quote.company_id === 2 && (
        <PrimaInfoModal
          setShowModal={setShowModal}
          quote={quote}
          guaranteesPrima={guaranteesPrima}
        />
      )}
      {showModal && quote.company_id === 4 && quote.product_id === 4 && (
        <ProfessionInfoModal
          userData={quote}
          setShowModal={setShowModal}
          docs={docs}
          set_informativi={set_informativi}
          extensions={extensions}
          requestToken={requestToken}
          selectableExtensions={selectableExtensions}
          profession={profession}
        />
      )}
      {showModal && quote.company_id === 1002 && quote.product_id === 4 && (
        <ProfessionWeBindModal
          userData={quote}
          setShowModal={setShowModal}
          docs={docs}
          set_informativi={set_informativi}
          extensions={extensions}
          requestToken={requestToken}
          selectableExtensions={selectableExtensions}
          profession={profession}
        />
      )}
      {(showModal && quote.company_id === 1001 && quote.product_id === 1001) && (
        <MalattiaNobisModal
          userData={quote}
          setShowModal={setShowModal}

        />
      )}
      {(showModal && quote.company_id === 1001 && quote.product_id === 1003) && (
        <CondominioNobisModal
          userData={quote}
          setShowModal={setShowModal}
        />
      )}

      {(showModal && quote.company_id === 1001 && quote.product_id === 1004) && (
        <RcFamigliaNobisModal
          userData={quote}
          setShowModal={setShowModal}
        />
      )}

      {showModal && quote.company_id === 15 && (
        <TutelaLegaleInfoModal quotation={quote} setShowModal={setShowModal} />
      )}

      {showModal && quote.company_id === 16 && (
        <GlobalAssistanceInfoModal quotation={quote} setShowModal={setShowModal} />
      )}

      {showModal && (quote.company_id === 8 && quote.product_id === 12) && (
        <SaluteInfoModal
          setShowModal={setShowModal}
          quote={quote}
        />
      )}

      {showModal && ((quote.company_id === 8 || quote.company_id === 16) && quote.product_id === 13) && (
        <AncillariInfoModal setShowModal={setShowModal} quote={quote} />
      )}

      {showModal && (quote.company_id == 8 && quote.product_id == 11) && (
        <CasaInfoModal setShowModal={setShowModal} quote={quote} />
      )}

      {showModal && (quote.company_id == 8 && quote.product_id == 14) && (
        <SanitariaStranieriInfoModal setShowModal={setShowModal} requestInfo={requestInfo} />
      )}

      {showModal && quote.company_id === 18 && (
        <GenialPiuInfoModal quotation={quote} setShowModal={setShowModal} />
      )}

      {showModal && quote.company_id === 19 && (
        <AmtrustInfoModal quotation={quote} setShowModal={setShowModal} docs={docs} />
      )}

      {showModal && quote.product_id === 1002 && (
        <InvaliditaPermanenteInfortunio setShowModal={setShowModal} />
      )}

      {showModal
        && quote.quotation_data_facile
        && quote.quotation_data_facile.coverages
        && (quote.company_id === 3 || quote.company_id === 21 || quote.company_id === 22) && (
          <FacileCompaniesInfoModal
            setShowModal={setShowModal}
            quote={quote}
          />
      )}

      {(quote.company_id === 1
        || quote.company_id === 17
        || quote.company_id === 2) && (
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            {quote.company_id === 1 && quote.product_id === 1 && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(1, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}
            {quote.company_id === 2 && quote.product_id === 1 && (
              <CompanyInfoElements
                onClick={() => {
                  let id = 6;

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'triglav') {
                    id = 34;
                  }

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'great_lakes') {
                    id = 31;
                  }

                  downloadResourceDocs(
                    id,
                    0,
                  );
                }}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}

            {quote.company_id === 17 && quote.product_id === 1 && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(18, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}

            {quote.company_id === 1 && quote.product_id === 3 && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(5, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}
            {quote.company_id === 17 && quote.product_id === 3 && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(20, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}
            {quote.company_id === 2 && quote.product_id === 3 && (
              <CompanyInfoElements
                onClick={() => {
                  let id = 7;

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'triglav') {
                    id = 35;
                  }

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'great_lakes') {
                    id = 32;
                  }

                  downloadResourceDocs(
                    id,
                    0,
                  );
                }}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}
            {quote.company_id === 2 && quote.product_id === 2 && (
              <CompanyInfoElements
                onClick={() => {
                  let id = 22;

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'triglav') {
                    id = 36;
                  }

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'great_lakes') {
                    id = 33;
                  }

                  downloadResourceDocs(
                    id,
                    0,
                  );
                }}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}

          </CompanyInformationContainer>
      )}

      {quote.company_id === 8 && quote.product_id === 12 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(16, 0)}
            title="Informativa Precontrattuale"
          >
            <img src={preContractIcon} alt="" />
            <p>Informativa Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.company_id === 8 && quote.product_id === 14 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(51, 0)}
            title="Informativa Precontrattuale"
          >
            <img src={preContractIcon} alt="" />
            <p>
              Informativa Precontrattuale
            </p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.company_id === 8 && quote.product_id === 11 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(15, 0)}
            title="Informativa Precontrattuale "
          >
            <img src={preContractIcon} alt="" />
            <p>{'Informativa Precontrattuale '}</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.product_id === 9 && quote.company_id === 16 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>

          {(() => {
            const docMap = {
              patente_motor: 37,
              vita_privata: 38,
              tutela_professionale: 48,
            };
            const docId = docMap[quote.sub_product];
            if (!docId) return null;
            return (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(docId, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            );
          })()}

        </CompanyInformationContainer>
      )}

      {quote.product_id === 13 && quote.company_id === 16 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(13, 0)}
            title="Informativa Precontrattuale"
          >
            <img src={preContractIcon} alt="" />
            <p>
              Informativa Precontrattuale
            </p>
          </CompanyInfoElements>

        </CompanyInformationContainer>
      )}

      {quote.product_id === 11 && quote.company_id === 16 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(39, 0)}
            title="Informativa Precontrattuale "
          >
            <img src={preContractIcon} alt="" />
            <p>{'Informativa Precontrattuale '}</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.product_id === 11 && quote.company_id === 1001 && (
        <CompanyInformationContainer>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(45, 0)}
            title="Informativa Precontrattuale "
          >
            <img src={preContractIcon} alt="" />
            <p>{'Informativa Precontrattuale '}</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.product_id === 10 && quote.company_id === 1001 && (
        <CompanyInformationContainer>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(40, 0)}
          >
            <img src={preContractIcon} alt="" />
            <p>Informativa Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.company_id === 19 && quote.product_id === 15 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          {(() => {
            const docMapping = {
              medici_dipendenti: 25,
              medici_liberi_professionisti: 27,
              medico_protetto: 26,
              professioni_sanitarie: 24,
            };
            let docId = docMapping[quote.sub_product];

            if (quote.product_id === 1000) {
              docId = 42;
            }

            if (!docId) return null;

            return (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(docId, 0)}
                title="Informativa Precontrattuale "
              >
                <img src={preContractIcon} alt="" />
                <p>{'Informativa Precontrattuale '}</p>
              </CompanyInfoElements>
            );
          })()}
        </CompanyInformationContainer>
      )}

      {quote.product_id === 1002 && quote.company_id === 19 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          <CompanyInfoElements onClick={() => downloadResourceDocs(46, 0)}>
            <img src={preContractIcon} alt="" />
            <p>Informazione Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}
      {quote.product_id === 1006 && quote.company_id === 1006 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => downloadResourceDocs(52, 0)}>
            <img src={preContractIcon} alt="" />
            <p>Informazione Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}
      {quote.product_id === 1000 && quote.company_id === 19 && (
        <CompanyInformationContainer>

          <CompanyInfoElements onClick={() => downloadResourceDocs(42, 0)}>
            <img src={preContractIcon} alt="" />
            <p>Informazione Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.manually_added_quotation_documents
        && quote.manually_added_quotation_documents.length > 0 && (
          <CompanyInformationContainer>
            {quote.manually_added_quotation_documents.map((doc) => (
              <CompanyInfoElements onClick={() => downloadDocument(doc.id)}>
                <img
                  src={
                    doc.type === 'preventive' ? preventiveIcon : preContractIcon
                  }
                  alt=""
                />
                <p>
                  {doc.type === 'preventive'
                    ? 'Preventivo'
                    : 'Informazioni Precontrattuali'}
                </p>
              </CompanyInfoElements>
            ))}
          </CompanyInformationContainer>
      )}
      {quote.company_id === 4 && quote.product_id === 4 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            {docs[profession.profession] !== '' && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(4, profession.profession)}
                title={`${docs[profession.profession]}`}
              >
                <img src={preventiveIcon} alt="" />
                <p>Questionario</p>
              </CompanyInfoElements>
            )}
            {set_informativi[profession.profession] !== '' && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(8, profession.profession)}
                title={`${set_informativi[profession.profession]}`}
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            )}
          </CompanyInformationContainer>
        </>
      )}

      {quote.company_id === 1002 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            {docs[profession.profession] !== '' && (
              <CompanyInfoElements
                onClick={() => downloadModuloDiProposta()}
                title={`${docs[profession.profession]}`}
              >
                <img src={preventiveIcon} alt="" />
                <p>Questionario</p>
              </CompanyInfoElements>
            )}
            {set_informativi[profession.profession] !== '' && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(41, profession.profession)}
                title={`${set_informativi[profession.profession]}`}
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            )}
          </CompanyInformationContainer>
        </>
      )}

      {quote.company_id === 15 && quote.information && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => setShowModal(!showModal)}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          <CompanyInfoElements onClick={() => downloadResourceDocs(23, 0)}>
            <img src={preContractIcon} alt="" />
            <p>Informazione Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.company_id === 18 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => setShowModal(!showModal)}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>

          {quote.product_id === 1 && (
            <CompanyInfoElements onClick={() => downloadResourceDocs(19, 0)} title="Informativa Precontrattuale">
              <img src={preContractIcon} alt="" />
              <p>Informativa Precontrattuale</p>
            </CompanyInfoElements>
          )}

          {quote.product_id === 2 && (
            <CompanyInfoElements onClick={() => downloadResourceDocs(28, 0)} title="Informativa Precontrattuale">
              <img src={preContractIcon} alt="" />
              <p>Informativa Precontrattuale</p>
            </CompanyInfoElements>
          )}

          {quote.product_id === 3 && (
            <CompanyInfoElements onClick={() => downloadResourceDocs(29, 0)} title="Informativa Precontrattuale">
              <img src={preContractIcon} alt="" />
              <p>Informativa Precontrattuale</p>
            </CompanyInfoElements>
          )}
        </CompanyInformationContainer>
      )}
      {quote.company_id === 1000 && (
        <CompanyInformationContainer>
          {quote.product_id === 1 && (
            <CompanyInfoElements onClick={() => downloadResourceDocs(30, 0)} title="Informativa Precontrattuale">
              <img src={preContractIcon} alt="" />
              <p>Informativa Precontrattuale</p>
            </CompanyInfoElements>
          )}

        </CompanyInformationContainer>
      )}

      {quote.company_id === 1001 && quote.product_id === 1 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => downloadResourceDocs(43, 0)} title="Informativa Precontrattuale">
            <img src={preContractIcon} alt="" />
            <p>Informativa Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.company_id === 21 && (
        <CompanyInformationContainer>
          {quote.quotation_data_facile && quote.quotation_data_facile.coverages && (
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
          )}
          {renderFacileFiles()}
          {
            quote.product_id === 1 && (
              <CompanyInfoElements onClick={() => downloadResourceDocs(17, 0)} title="Informativa Precontrattuale">
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            )
          }
        </CompanyInformationContainer>
      )}

      {
        quote.company_id === 9 && (
          <CompanyInformationContainer>
            {quote.product_id === 1 && (
              <CompanyInfoElements onClick={() => downloadResourceDocs(17, 0)} title="Informativa Precontrattuale">
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            )}
            {quote.product_id === 2 && (
              <CompanyInfoElements onClick={() => downloadResourceDocs(21, 0)} title="Informativa Precontrattuale">
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            )}
            {quote.product_id === 3 && (
              <CompanyInfoElements onClick={() => downloadResourceDocs(50, 0)} title="Informativa Precontrattuale">
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            )}
          </CompanyInformationContainer>
        )
      }

      {
        quote.company_id === 22 && (
          <CompanyInformationContainer>
            {quote.quotation_data_facile && quote.quotation_data_facile.coverages && (
              <CompanyInfoElements onClick={() => openModal()}>
                <img src={infoIcon} alt="" />
                <p>Maggiori informazioni</p>
              </CompanyInfoElements>
            )}
            {renderFacileFiles()}
          </CompanyInformationContainer>
        )
}

      {quote.company_id === 3 && (
        <CompanyInformationContainer>
          {quote.quotation_data_facile && quote.quotation_data_facile.coverages && (
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
          )}
          {renderFacileFiles()}
        </CompanyInformationContainer>
      )}

      {
        quote.company_id === 1001 && (quote.product_id === 1001 || quote.product_id === 1003 || quote.product_id === 1004) && (
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => setShowModal(!showModal)}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            {(() => {
              const docMap = {
                1001: 44,
                1003: 47,
                1004: 49,
              };
              const docId = docMap[quote.product_id];
              if (!docId) return null;
              return (
                <CompanyInfoElements onClick={() => downloadResourceDocs(docId, 0)} title="Informativa Precontrattuale">
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>
              );
            })()}
          </CompanyInformationContainer>
        )
      }

      {quote.company_id === 1010 && quote.product_id === 1 && (
        <CompanyInformationContainer>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(58, 0)}
            title="Informativa Precontrattuale"
          >
            <img src={preContractIcon} alt="" />
            <p>Informativa Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.company_id === 1011 && quote.product_id === 1 && (
        <CompanyInformationContainer>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(59, 0)}
            title="Informativa Precontrattuale"
          >
            <img src={preContractIcon} alt="" />
            <p>Informativa Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.company_id === 23 && quote.product_id === 1 && (
        <CompanyInformationContainer>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(64, 0)}
            title="Informativa Precontrattuale"
          >
            <img src={preContractIcon} alt="" />
            <p>Informativa Precontrattuale</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

    </>
  );
}

export default CompanyInfoComponent;
